import { EMessagesActionTypes } from '../../actions/messages';
import { ERequestApiStatus, TAppState } from '../../types/appState';
import { EMobileLayoutActiveSide } from '../../types/mobileSide';
import { TReduxActions } from '../../types/redux/actions';
import { addNewChat } from '../../utils/addNewChat';
import { addMessagesInChat, setMessageReadStatus } from '../../utils/messageUtils';

export function messagesReducer(state: TAppState, action: TReduxActions): TAppState {
  switch (action.type) {
    case EMessagesActionTypes.SetAsRead:
      return {
        ...state,
        openedChats: {
          ...state.openedChats,
          [action.payload.chatId]: {
            ...state.openedChats[action.payload.chatId],
            pages: setMessageReadStatus(
              state.chatWindow.messagesMap,
              action.payload.messageIds,
              state.openedChats[action.payload.chatId].pages,
            ),
          },
        },
      };
    case EMessagesActionTypes.SetMessagesPending:
      return {
        ...state,
        chatWindow: {
          ...state.chatWindow,
          currentOpenedChatId: action.payload.chatId,
        },
        openedChats: addNewChat({
          openedChats: state.openedChats,
          chats: state.chatList.chats,
          currentChatId: action.payload.chatId,
        }),
        mobileSide: EMobileLayoutActiveSide.Center,
      };
    case EMessagesActionTypes.SetMessagesFulfilled:
      return {
        ...state,
        openedChats: addMessagesInChat({
          openedChats: state.openedChats,
          messages: action.payload.messages,
          currentOpenedChatId: state.chatWindow.currentOpenedChatId as string,
          messagesMap: state.chatWindow.messagesMap,
          userId: state.user.userId,
        }),
      };
    case EMessagesActionTypes.SetMessagesFailed:
      return {
        ...state,
        openedChats: {
          ...state.openedChats,
          [action.payload.chatId]: {
            ...state.openedChats[action.payload.chatId],
            status: ERequestApiStatus.Failed,
            error: action.payload.error,
          },
        },
      };
    default:
      return state;
  }
}
